import {
  useState,
} from 'react';
import {
  DateTime,
} from 'luxon';
import {
  toast,
} from 'react-toastify';
import {
  useDispatch,
} from 'react-redux';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from './styled';

const getDate = (isoDate: string) => DateTime.fromISO(isoDate).toFormat('d LLL y');

const getDuration = (secs: number) => {
  const minutes = `${Math.floor(secs / 60)}`;
  const seconds = `${secs % 60}`;
  const stringedMinutes = minutes.length === 1 ? `0${minutes}` : `${minutes}`;
  const stringedSeconds = seconds.length === 1 ? `0${seconds}` : `${seconds}`;
  return `${stringedMinutes}:${stringedSeconds}`;
};

type Props = {
  video: any,
  readOnly: boolean,
  onRemove: { (video: any): void },
  onChangeName?: { (videoId: number, newName: string): void },
};

const Video = ({
  video,
  readOnly,
  onRemove,
  onChangeName,
}: Props) => {
  const [isPlaying, setPlay] = useState(false);
  const dispatch = useDispatch();

  const handleNameChange = (newName: string) => {
    if (!readOnly && newName && newName !== video.name && onChangeName) {
      onChangeName(video.id, newName);
    }
  };

  return (
    <S.Video>
      <S.Preview
        style={{ backgroundImage: `url(${video.preview_picture_url})` }}
      >
        {isPlaying ? (
          <S.Frame
            src={`${video.embed_url}?autoplay=1`}
            allowFullScreen
          />
        ) : (
          <S.PlayIcon
            onClick={() => {
              if (video.embed_url) {
                setPlay(true);
                dispatch({
                  type: 'GC_ANALYTICS',
                  eventKey: 'played_video',
                });
              } else {
                toast.error('Video is still processing, please wait.');
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="svg2592"
              version="1.1"
              viewBox="0 0 9.8093395 10.78689"
              height="10.78689mm"
              width="9.8093395mm"
              strokeWidth="currentColor"
            >
              <defs id="defs2586" />
              <g transform="translate(-103.95247,-117.07084)" id="layer1">
                <path
                  d="m 105.50046,118.12918 c -0.44168,0 -0.48966,0.54398 -0.48966,0.77752 v 7.11517 c 0,0.23389 0.048,0.77752 0.48966,0.77752 0.1584,0 0.34854,-0.0614 0.54998,-0.17744 l 6.16162,-3.55741 c 0.31256,-0.18027 0.49142,-0.39935 0.49142,-0.60008 0,-0.20108 -0.17886,-0.4198 -0.49142,-0.60043 l -6.16162,-3.55741 c -0.20144,-0.11606 -0.39158,-0.17744 -0.54998,-0.17744 m 0,9.72855 c -0.77047,0 -1.54799,-0.56762 -1.54799,-1.83586 v -7.11517 c 0,-1.26824 0.77752,-1.83586 1.54799,-1.83586 0.3489,0 0.7119,0.1076 1.07915,0.31927 l 6.16161,3.55776 c 0.64876,0.3743 1.02059,0.9271 1.02059,1.51659 0,0.58914 -0.37183,1.14194 -1.02059,1.51624 l -6.16161,3.55776 c -0.36725,0.21167 -0.73025,0.31927 -1.07915,0.31927"
                  style={{
                    fillOpacity: 1,
                    fillRule: 'nonzero',
                    strokeWidth: 0.352777,
                  }}
                  id="path102"
                />
              </g>
            </svg>
          </S.PlayIcon>
        )}
      </S.Preview>
      <Flex
        width="100%"
        height="36%"
        padding="10px"
        spacing={5}
      >
        <Flex column width="100%">
          <S.EditableName
            html={(video.name || '').split('.')[0]}
            disabled={readOnly}
            onBlur={(e) => {
              handleNameChange(e.target.textContent || '');
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.target?.blur();
              }
            }}
          />
          <Text
            size="14px"
            weight={500}
          >
            {`Uploaded: ${getDate(video.uploaded_at || video.created_at)}`}
          </Text>
          <Flex
            margin="8px 0 0 0"
            spacing={5}
            align="center"
            className="primary-color"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={12}
              height={12}
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 6v6l4 2" />
              <circle cx="12" cy="12" r="10" />
            </svg>
            <Text
              size="12px"
              color="#cbcacb"
              weight={500}
            >
              {getDuration(video.duration)}
            </Text>
          </Flex>
        </Flex>
        {onRemove && (
          <Flex clickable onClick={() => onRemove(video)}>
            <SVG.TrashAlt size={20} stroke="#ced0d0" />
          </Flex>
        )}
      </Flex>
    </S.Video>
  );
};

export default Video;
